__webpack_require__.p = "https://dev-admin.dev.dim.atea.com/";